import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibDrillDownPlus',
  props: {
    commentInput: {
      type: Object,
      required: true
    },
    topicInput: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    },
    multiSelect: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      showCommentInput: false,
      topicsArray: []
    };
  },
  computed: {
    fibSelectOptionProps: function fibSelectOptionProps() {
      if (this.multiSelect) {
        return {
          'drill-down-plus': true
        };
      }

      return;
    },
    topicsLabels: function topicsLabels() {
      return this.topicsArray.map(function (topic) {
        return topic.label;
      });
    },
    componentType: function componentType() {
      return this.multiSelect ? 'fib-select-option' : 'fib-select';
    },
    selectedTopics: function selectedTopics() {
      var _this$value;

      var topics = this.multiSelect ? this.topicsLabels : (_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.topics;
      return topics !== null && topics !== void 0 ? topics : null;
    },
    formattedTopics: function formattedTopics() {
      var _this$value2;

      //create new array from values to stop editing on reference to store
      return this.multiSelect ? _toConsumableArray(this.topicsArray) : (_this$value2 = this.value) === null || _this$value2 === void 0 ? void 0 : _this$value2.topics;
    }
  },
  methods: {
    handleCheckBox: function handleCheckBox(value) {
      this.updateTopics(value);
      this.showCommentInput = !!this.topicsArray.length;
      this.emitValues((this.value || {}).comment);
    },
    handleDropDown: function handleDropDown(topic) {
      this.showCommentInput = !!topic;
      this.$emit('input', {
        topics: topic,
        comment: this.value ? this.value.comment : null
      });
    },
    emitValues: function emitValues(value) {
      this.$emit('input', {
        topics: this.formattedTopics,
        comment: this.value ? value : null
      });
    },
    updateTopics: function updateTopics(value) {
      if (!this.topicsArray.some(function (st) {
        return st.label === value.label;
      })) {
        this.topicsArray.push(value);
      } else {
        this.topicsArray = this.topicsArray.filter(function (st) {
          return st.label !== value.label;
        });
      }
    }
  }
};